import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { t } from '../utils/i18n';
import { sendEvent } from '../utils/analytics';
import { ENCAJA_LOGIN_URL, ENCAJA_PLANS_ANCHOR } from '../utils/encajaBrand';
import './EncajaStarBanner.css';

function trackEncajaClick(action, label = '') {
  sendEvent('landing_section_event', {
    section: 'encaja_banner',
    action,
    label
  });
}

export default function EncajaStarBanner({ language }) {
  return (
    <section id="encaja" className="encaja-star-banner" aria-labelledby="encaja-banner-heading">
      <div className="encaja-star-banner-glow" aria-hidden />
      <Container>
        <div className="encaja-star-banner-shell">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="encaja-star-banner-badge mb-3">
                {t('landing.encajaBadge', language)}
              </div>
              <p className="encaja-star-banner-byline mb-2">{t('landing.encajaByLine', language)}</p>
              <h2 id="encaja-banner-heading" className="encaja-star-banner-title mb-2">
                <span className="encaja-star-banner-brand">{t('landing.encajaBrandName', language)}</span>
                <span className="encaja-star-banner-tagline">{t('landing.encajaTagline', language)}</span>
              </h2>
              <p className="encaja-star-banner-lead mb-4">{t('landing.encajaDescription', language)}</p>
              <ul className="encaja-star-banner-features list-unstyled d-flex flex-wrap gap-2 mb-4">
                <li>{t('landing.encajaFeatureInventory', language)}</li>
                <li>{t('landing.encajaFeatureClients', language)}</li>
                <li>{t('landing.encajaFeatureSales', language)}</li>
                <li>{t('landing.encajaFeatureBilling', language)}</li>
              </ul>
              <div className="encaja-star-banner-ctas d-flex flex-wrap gap-3">
                <a
                  href={ENCAJA_LOGIN_URL}
                  className="encaja-star-banner-btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEncajaClick('click_primary_trial')}
                >
                  {t('landing.encajaPrimaryCta', language)}
                </a>
                <a
                  href={ENCAJA_PLANS_ANCHOR}
                  className="encaja-star-banner-btn-secondary"
                  onClick={() => trackEncajaClick('click_secondary_plans')}
                >
                  {t('landing.encajaSecondaryCta', language)}
                </a>
              </div>
            </Col>
            <Col lg={5} className="d-none d-lg-block">
              <div className="encaja-star-banner-mock" aria-hidden>
                <div className="encaja-star-banner-mock-chrome">
                  <span className="encaja-star-banner-mock-dots">
                    <i /><i /><i />
                  </span>
                  <span className="encaja-star-banner-mock-url">encaja.estumejoropcion.com</span>
                </div>
                <div className="encaja-star-banner-mock-status">
                  <span className="encaja-star-banner-mock-live" />
                  {t('landing.encajaMockLabel', language)}
                </div>
                <div className="encaja-star-banner-mock-metrics">
                  <div>
                    <span>{t('landing.encajaMockMetricOrders', language)}</span>
                    <strong>{t('landing.encajaMockMetricOrdersValue', language)}</strong>
                  </div>
                  <div>
                    <span>{t('landing.encajaMockMetricStock', language)}</span>
                    <strong>{t('landing.encajaMockMetricStockValue', language)}</strong>
                  </div>
                  <div>
                    <span>{t('landing.encajaMockMetricRevenue', language)}</span>
                    <strong>{t('landing.encajaMockMetricRevenueValue', language)}</strong>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
